<script>
import {mapState} from "vuex";
import {IframeService} from "@/api/IframeService";

export default {
  async mounted() {
    try {
      const response = await IframeService.getPageById(this.$route.params.id)
      this.block = response.data
      this.isLoading = false
      this.prefillForm()
    } catch (err) {
      //todo handle err
      console.log(err)
    }
  },
  methods: {
    prefillForm: function() {
      this.blockForm = {...this.block}
      if(this.blockForm.lang) {
        this.blockForm.lang = this.$store.state.languages.filter(lang => lang.lang === this.blockForm.lang)[0] || null
      }
    },
    handleCancel: function() {
      this.$router.push({path:`/${this.iframeService.slug}/${this.iframeService.slug}/blocks-builder`})
    },
  },
  computed: {
    ...mapState({
      'pageTypes': (state) => state.iframe.pageTypes,
    }),
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
      //return this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
    },

  }
}
</script>
